import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_BOOKKEEPING = "/member/bookkeeping";
export const PARAMETER_TAB = "tab";

export const BOOKKEEPING_TAB_SLUGS = [
  "dashboard",
  "profit-and-loss",
  "transactions",
  "reports"
] as const;

export type BookkeepingTabSlug = (typeof BOOKKEEPING_TAB_SLUGS)[number];

export const PATH_BOOKKEEPING_TAB = `${PATH_BOOKKEEPING}/:${PARAMETER_TAB}`;
export const PATH_BOOKKEEPING_TRANSACTIONS = `${PATH_BOOKKEEPING}/transactions`;

export const routeHelpersBookkeeping = createRouteHelpers(PATH_BOOKKEEPING);
export const routeHelpersBookkeepingTab = createRouteHelpers<{
  tab: BookkeepingTabSlug;
}>(PATH_BOOKKEEPING_TAB);
